/* eslint-disable jsx-a11y/no-autofocus */
import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./form-field.module.scss"
import CopyContainer from "../copy-container"

const FormField = ({
  label,
  labelHtml,
  form,
  field,
  type,
  value,
  changeEvent,
  required,
  readOnly,
  options,
  disabled,
  checked,
  light,
  min,
  max,
  wordCount,
  autofocus,
}) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  const labelElement = (
    <label
      className={`${styles.label} ${
        type !== "checkbox" ? styles.label__field : ""
      } ${light ? styles.label__light : ""} ${
        type === "textarea" ? styles.label__textarea : ""
      }`}
      htmlFor={`${form}__${field}`}
    >
      {labelHtml ? <CopyContainer content={labelHtml} /> : label}
    </label>
  )

  if (type === "select") {
    const dropdownPrefix =
      "aeiouAEIOU".indexOf(label[0]) >= 0
        ? "dropdown_prefix_vowel"
        : "dropdown_prefix"
    return (
      <div className={styles.select}>
        {labelElement}
        <select
          className={`${styles.selectField} ${
            light ? styles.selectField__light : ""
          }`}
          required={required}
          id={`${form}__${field}`}
          name={field}
          value={value}
          onChange={changeEvent}
          disabled={disabled}
        >
          <option className={styles.option} value="" defaultValue disabled>
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === dropdownPrefix
              )?.value
            }{" "}
            {label.length > 50
              ? allSanityDictionary.nodes.find(
                  (item) => item.key.current === "option"
                )?.value
              : label}
          </option>
          {options.map((item) => (
            <option
              className={styles.option}
              key={item.value}
              value={item.value}
            >
              {item.name ? item.name : item.value}
            </option>
          ))}
        </select>
      </div>
    )
  }
  if (type === "textarea") {
    return (
      <div>
        {labelElement}
        <textarea
          className={`${styles.input} ${styles.input__textarea} ${
            light ? styles.input__light : ""
          }`}
          required={required}
          id={`${form}__${field}`}
          name={field}
          type={type}
          value={value}
          onChange={changeEvent}
          readOnly={readOnly}
          disabled={disabled}
        />
        {min || max ? (
          <div
            className={`${styles.wordCount} ${
              light ? styles.wordCount__light : ""
            }`}
          >
            {wordCount} /{" "}
            {min
              ? `${
                  allSanityDictionary.nodes.find(
                    (item) => item.key.current === "min"
                  )?.value
                } ${min}`
              : ""}{" "}
            {min && max ? "-" : ""}{" "}
            {max
              ? `${
                  allSanityDictionary.nodes.find(
                    (item) => item.key.current === "max"
                  )?.value
                } ${max}`
              : ""}{" "}
            {
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "words"
              )?.value
            }
          </div>
        ) : (
          ""
        )}
      </div>
    )
  }

  return (
    <div className={type === "checkbox" ? styles.checkbox : ""}>
      {type === "checkbox" ? "" : labelElement}
      <input
        className={`${styles.input} ${
          type === "checkbox" ? styles.input__checkbox : ""
        } ${light ? styles.input__light : ""}`}
        required={required}
        id={`${form}__${field}`}
        name={field}
        autoComplete={type === "email" ? "email" : "off"}
        type={type}
        value={value}
        onChange={changeEvent}
        readOnly={readOnly}
        disabled={disabled}
        checked={checked}
        placeholder={
          type !== "checkbox"
            ? `${label.substr(0, 50)}${label.length > 50 ? "..." : ""}`
            : null
        }
        autoFocus={autofocus}
      />
      {type === "checkbox" ? labelElement : ""}
    </div>
  )
}

export default FormField

FormField.propTypes = {
  label: PropTypes.string,
  labelHtml: PropTypes.object,
  form: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  changeEvent: PropTypes.func,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  checked: PropTypes.bool,
  light: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  wordCount: PropTypes.number,
  autofocus: PropTypes.bool,
}

FormField.defaultProps = {
  label: "",
  labelHtml: null,
  type: "text",
  required: false,
  changeEvent: null,
  readOnly: false,
  disabled: false,
  options: [],
  checked: false,
  light: false,
  min: null,
  max: null,
  wordCount: 0,
  autofocus: false,
}
